import { DirectusStatus } from './directus-status';
import { Area } from './area';

export class Announcement {
  id?: string;
  external_id?: string;
  status?: DirectusStatus.PUBLISHED | DirectusStatus.DRAFT | DirectusStatus.ARCHIVED;
  featured_image: string;
  date: string;
  link: string;
  slug: string;
  area?: string | Area;
  translations: AnnouncementTranslation[];
  announcement_type?: { municipality_announcement_type_id: string }[];
  author?: string;
}

export class AnnouncementTranslation {
  languages_code: string;
  title?: string;
  excerpt?: string;
  content?: string;
}

export interface AnnouncementType {
  id:
    | AnnouncementTypeType.ANNOUNCEMENT
    | AnnouncementTypeType.NOTICE
    | AnnouncementTypeType.WARNING
    | AnnouncementTypeType.BLOG;
  translations: AnnouncementTypeTranslation[];
}

export interface AnnouncementTypeTranslation {
  languages_code: string;
  label: string;
}

export enum AnnouncementTypeType {
  ANNOUNCEMENT = 'announcement',
  NOTICE = 'notice',
  WARNING = 'warning',
  BLOG = 'blog',
}
